import {Component, OnInit} from '@angular/core';
import {ApiService} from '../../../services/api.service';
import {LoginService} from '../../../services/login.service';
import {NotificationsService} from 'angular2-notifications';
import {ActivatedRoute} from '@angular/router';
import {BarChartComponent} from '../zoomView/bar-chart/bar-chart.component';
import {ModalService} from '../../../services/modalService/modal.service';
import {UtilsService} from '../../../services/utils.service';
import { TranslateService } from '@ngx-translate/core';
import { BackendTranslateService } from '../../../helper/backend-translate.service';
@Component({
  selector: 'app-denied-features',
  templateUrl: './denied-features.component.html',
  styleUrls: ['./denied-features.component.css', '../myreports.component.css']
})
export class DeniedFeaturesComponent implements OnInit {

  ruid: string;
  public barChartData = [];
  public options = {
    height: 400,
    titlePosition: 'out',
      chartArea: {height: '100%', width: '60%', left: 150},
    vAxis: {title: this.translate.instant('reports.feature'), viewWindowMode: 'explicit', },
    colors: ['#FAE688'],
    legend: 'none',
    showAnnotations: true
  };
  isLoggedIn = false;
  isLicense: string;
  deniedFeatures: any = {};
  chartError = false;

  constructor(private apiService: ApiService,
              private loginService: LoginService,
              private route: ActivatedRoute,
              private notifications: NotificationsService,
              private modalService: ModalService,
              private utilService: UtilsService,
              private translate: TranslateService,
              private backendTranslate: BackendTranslateService) {
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      if (params.ruid) {
        this.ruid = params.ruid;
        if (this.ruid === 'demo') {
          this.reportsData();
        } else {
          this.loginService.isLoggedIn()
            .subscribe((currentUser) => {
                this.isLoggedIn = currentUser.isLoggedIn;
                if (this.isLoggedIn) {
                this.apiService.getSummary(this.ruid)
                  .subscribe((res) => {
                    this.isLicense = res.isLicense;
                    if (!res.isLicense) {
                      this.reportsData();
                    }
                  }, (error) => {
                      this.notifications.error(this.translate.instant('common.error'), this.apiService.getMessageFromError(error, this.translate.instant('reports.invalidRuid')));
                  });
              }
            });
        }
      }
    });
  }

  reportsData() {
    this.apiService.getChartData(this.ruid, 'DENIALS_BY_FEATURE')
      .subscribe((res) => {
        res.data[0] = this.backendTranslate.translateCollection(res.data[0]);
        this.deniedFeatures = res;
        if (res.data[1]) {
          this.barChartData = this.deniedFeatures.data;
          this.utilService.updateChartAreaFromData(this.barChartData, this.options);
        }
      }, (error) => {
          this.notifications.error(this.translate.instant('common.error'), this.apiService.getMessageFromError(error, this.translate.instant('reports.deniedFeatures.fail')));
      });
  }

  zoomView() {
      if (this.barChartData.length === 0) {
          return;
      }
    this.modalService.open(BarChartComponent, {
      title: this.translate.instant('reports.deniedFeatures.top10'),
      data: {
        chartData: this.deniedFeatures,
        isLicense: this.isLicense,
        options: this.options
      }
    }).subscribe(model => {
    });
  }

}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/reports/myReports/denied-features/denied-features.component.ts